import { makeContractPaymentsRepository } from 'modules/customer/infra/repositories';

import { CreatePixPendencyPaymentUseCase } from './implementations/CreatePixPendencyPaymentUseCase';

let instance: CreatePixPendencyPaymentUseCase | null = null;

export default function makeCreatePixPendencyPaymentUseCase() {
  if (!instance) {
    const repository = makeContractPaymentsRepository();

    instance = new CreatePixPendencyPaymentUseCase(repository);
  }

  return instance;
}
